import { combineReducers } from "@reduxjs/toolkit";
import notificationsSlice from "./notificationsSlice";

export default combineReducers({
  notification: notificationsSlice,
});
